import { useUserStore } from '../../store/useUserStore';
import { useNavigate } from 'react-router-dom';
import Url from '../../data/url';
import { TextField } from '@mui/material';
import { useTranslation } from '../../hook/useTranslation';

interface BottomFixedTextFieldProps {
  inputValue: string;
  setInputValue: (value: string) => void;
  onSubmit?: () => void;
}

export default function BottomFixedTextField({
  inputValue,
  setInputValue,
  onSubmit,
}: BottomFixedTextFieldProps) {
  const navigate = useNavigate();
  const user = useUserStore();
  const { t } = useTranslation();

  const handleSubmit = () => {
    if (!user?.isLoggedIn) {
      navigate(Url.Login);
      return;
    }
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <div
      className="flex p-4 justify-center w-full text-base font-bold leading-6 text-center text-white bg-white"
      style={{ zIndex: 1000 }}
    >
      <TextField
        variant="outlined"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        size="small"
        placeholder={t('common.comment_placeholder')}
        fullWidth
        sx={{ border: 'none' }}
        InputProps={{
          sx: {
            borderRadius: '8px',
            backgroundColor: '#F8F8F8',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none', // 테두리 없애기
            },
            '& input::placeholder': {
              color: '#969696',
              opacity: 1,
              fontSize: '14px',
            },
          },
        }}
      />
      <button
        type="button"
        className="py-3 px-4 text-[14px]"
        style={
          (inputValue?.length >= 1
            ? { color: '#42A9AA' }
            : { color: '#C6C6C6' }) as React.CSSProperties
        }
        onClick={inputValue?.length >= 1 ? handleSubmit : undefined}
      >
        {t('common.register')}
      </button>
    </div>
  );
}
